export async function openPagePayment(value, navigate) {
    const url = `/payament/${value}`;
    navigate(url);
}